import { useSearch } from '@tanstack/react-router';
import { useInitializeFilters } from '../hooks/use-initialize-filters';
import { AppointmentAnalyticsV2ViewContainer } from './views/charts-view';
import { CompareLocationsView } from './views/compare-locations-view';
import { ProspectPatientListView } from './views/prospect-patient-list-view';

export const AppointmentAnalyticsV2 = () => {
  const { comparingLocations, showingProspectList } = useSearch({ from: '/analytics/appointment' });

  useInitializeFilters();

  if (comparingLocations) {
    return <CompareLocationsView />;
  }

  if (showingProspectList) {
    return <ProspectPatientListView />;
  }

  return <AppointmentAnalyticsV2ViewContainer />;
};
